import { Route, Routes } from "react-router-dom";
import { CatalogBinProvider } from "./context/CatalogBinContext";
import { CatalogBinPage } from "./pages/CatalogBinPage";

type Props = {};
const CatalogBins = (props: Props) => {
  return (
    <CatalogBinProvider>
      <Routes>
        <Route index element={<CatalogBinPage />}></Route>
        <Route path=":binId" element={<CatalogBinPage />}></Route>
      </Routes>
    </CatalogBinProvider>
  );
};
export default CatalogBins;
